<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="e3-svg" :width="Number(size)" :height="Number(size)" viewBox="0 0 24 24">
        <path fill="currentColor" d="M13 9V3.5L18.5 9M6 2c-1.11 0-2 .89-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6H6z"/>
    </svg>
</template>

<script>
export default {
    name: 'FileIcon',
    props: {
        size: {
            type: [String, Number],
            default: 24
        }
    }
};
</script>
